// useScreenSize.js
import { useState, useEffect } from 'react';

const UserScreenSize = () => {
    const screen = window.innerWidth > 550 ? 'web':'mobile';
    const [screenSize, setScreenSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
        screen: screen
    });

    useEffect(() => {
        const handleResize = () => {
            const screenType = window.innerWidth > 550 ? 'web':'mobile';
            setScreenSize({
                width: window.innerWidth,
                height: window.innerHeight,
                screen: screenType
            });
        };

        window.addEventListener('resize', handleResize);

        // Clean up the event listener when the component unmounts
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return screenSize;
};

export default UserScreenSize;